import React from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import formatPhoneNumber from '../util/format-phone-number'


function AddressForm({address, onSave, isShipping, disabled, showErrors}) {

  const autoCompletePrefix = isShipping ? 'shipping' : 'billing'

  return (
    <React.Fragment>
      <Grid container spacing={24}>
        <Grid item xs={12}>
          <TextField
            disabled={disabled}
            required
            id="companyName"
            name="companyName"
            label="Company Name"
            fullWidth
            autoComplete="organization name"
            onChange={e => {onSave({companyName: e.target.value})}}
            error={showErrors && !!address._errors.companyName}
            value={address.companyName || ''}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            disabled={disabled}
            required
            id="address1"
            name="address1"
            label="Address line 1"
            fullWidth
            autoComplete={`${autoCompletePrefix} address-line1`}
            onChange={e => {onSave({address1: e.target.value})}}
            error={showErrors && !!address._errors.address1}
            value={address.address1 || ''}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            disabled={disabled}
            id="address2"
            name="address2"
            label="Address line 2"
            fullWidth
            autoComplete={`${autoCompletePrefix} address-line2`}
            onChange={e => {onSave({address2: e.target.value})}}
            error={showErrors && !!address._errors.address2}
            value={address.address2 || ''}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            disabled={disabled}
            required
            id="city"
            name="city"
            label="City"
            fullWidth
            autoComplete={`${autoCompletePrefix} address-level2`}
            onChange={e => {onSave({city: e.target.value})}}
            error={showErrors && !!address._errors.city}
            value={address.city || ''}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            disabled={disabled}
            required
            id="state"
            name="state"
            label="State/Province/Region"
            fullWidth
            onChange={e => {onSave({state: e.target.value})}}
            error={showErrors && !!address._errors.state}
            value={address.state || ''}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            disabled={disabled}
            required
            id="zip"
            name="zip"
            label="Zip / Postal code"
            fullWidth
            autoComplete={`${autoCompletePrefix} postal-code`}
            onChange={e => {onSave({zip: e.target.value})}}
            error={showErrors && !!address._errors.zip}
            value={address.zip || ''}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            disabled={disabled}
            required
            id="country"
            name="country"
            label="Country"
            fullWidth
            autoComplete={`${autoCompletePrefix} country`}
            onChange={e => {onSave({country: e.target.value})}}
            error={showErrors && !!address._errors.country}
            value={address.country || ''}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            disabled={disabled}
            required
            id="phone"
            name="phone"
            label="Phone"
            fullWidth
            autoComplete={`${autoCompletePrefix} tel`}
            onChange={e => {onSave({phone: formatPhoneNumber(e.target.value)})}}
            error={showErrors && !!address._errors.phone}
            value={address.phone || ''}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default AddressForm;